import {Brick, Order, Predicate, Query, registerBrick, WorkflowObjectState} from 'olympe';
import { getLogger } from '@olympeio/core';
import BCP from './DM_BCP.js';
import {BCP_WORKFLOW_STATES} from './BcpWorkflowAuthorizations';

export default class GetUserBCPs extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} userId
     * @param {string} email
     * @param {boolean} isAdmin
     * @param {function()} forwardEvent
     * @param {function(!Array<!BCP>)} setBCPs
     * @param {function(!Map<string, !WorkflowObjectState>)} setWorkflows
     */
    update($, [userId, email, isAdmin], [forwardEvent, setBCPs, setWorkflows]) {
        const logger = getLogger('GetUserBCPs');
        const mail = email ? email : '';
        // Fetch all instances if user is admin
        let query = Query.instancesOf(BCP).sortBy(BCP.requestDateProp, Order.DESC);

        const mailRegex = new RegExp(`.*${mail.toLowerCase()}`);
        // Find requests where user is linked with the request
        if (!isAdmin) {
            query = query.filter(Predicate.or(
                Predicate.regex(BCP.requestorProp, mailRegex),
                Predicate.regex(BCP.businessPartnerProp, mailRegex),
                Predicate.regex(BCP.procurementManagerProp, mailRegex),
                Predicate.regex(BCP.technicalApplicationGroupProp, mailRegex),
                Predicate.regex(BCP.qualityAssuranceProp, mailRegex),
            ));
        }
        // retrieve workflow objects as well
        query = query.andReturn().follow(WorkflowObjectState.currentObjectRel.getInverse()).andReturn();

        // Run fetch
        query.execute().then((queryResult) => {
            const bcpAndWorkflows = queryResult.toArray();
            const bcps = bcpAndWorkflows.filter(this.filterBCP.bind(this, isAdmin, mailRegex)).map(([bcp]) => bcp);
            // bcps.sort((bcp1, bcp2) => {
            //     const bcpComparisonStatus = bcp1.get(BCP.statusProp) - bcp2.get(BCP.statusProp);
            //     if (bcpComparisonStatus !== 0) {
            //         // only sort if bcp comparison status is identical already.
            //         return bcpComparisonStatus;
            //     }
            //     // compare only year, month and day
            //     const dateComparison = bcp1.get(BCP.requestDateProp).toISOString().slice(0, 10).localeCompare(bcp2.get(BCP.requestDateProp).toISOString().slice(0, 10));
            //     const requestorComparison = bcp1.get(BCP.requestorProp).localeCompare(bcp2.get(BCP.requestorProp));
            //     if (dateComparison !== 0) {
            //         // if not equal, return the result of the comparison
            //         // negative means first is smaller
            //         // positive means second is smaller
            //         // we invert as we want most recent first (descending order)
            //         return -dateComparison;
            //     } else {
            //         return requestorComparison;
            //     }
            // });
            setBCPs(bcps);
            setWorkflows(new Map(bcpAndWorkflows.map(([bcp, workflowObject]) => [bcp.getTag(), workflowObject])))
        })
            .catch(error => {
                logger.error(error);
                setBCPs([]);
                setWorkflows(new Map());
            }).finally(() => {
                forwardEvent();
            });
    }

    /**
     * @param {boolean} isAdmin
     * @param {RegExp} mailRegex
     * @param {[BCP, WorkflowObjectState]} bcpAndWorkflows
     * @return {boolean}
     */
    filterBCP(isAdmin, mailRegex, [bcpRequest, workflowObject]) {
        const businessPartner = bcpRequest.get(BCP.businessPartnerProp);
        const procurementManager = bcpRequest.get(BCP.procurementManagerProp);
        const requestor = bcpRequest.get(BCP.requestorProp);
        const currentState = workflowObject.get(WorkflowObjectState.stateProp);
        // keep BCP request if user is admin
        return isAdmin
            // keep BCP request if user is requestor
            || (mailRegex.test(requestor))
            // keep BCP request if you are BP and request is waiting for BP approval
            || (currentState === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP && (mailRegex.test(businessPartner)))
            // keep BCP request if you are PM and request is waiting for PM approval
            || (currentState === BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM && (mailRegex.test(procurementManager)));
    }
}

registerBrick('0188436a7e2a04081e44', GetUserBCPs);
